module.exports = __webpack_public_path__ + "img/carousel02.240d732e.webp";